import { Directive, HostListener, Optional } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
  selector: '[trimValue]'
})
export class TrimInputValueDirective {

  constructor(@Optional() private ngControl: NgControl) {
    
  }

  ngOnInit(): void {
    if (!this.ngControl) {
      console.warn('TrimInputDirective required ngModel, formControl or formControlName.');
      return;
    }

  }

  @HostListener('blur', [
    '$event.target',
    '$event.target.value',
  ])
  onBlur(el: any, value: string): void {
    if ('function' === typeof value.trim && value.trim() !== value) {

      el.value = value.trim();
      const event = document.createEvent('Event');
      event.initEvent('input', false, false);
      el.dispatchEvent(event);

      const eventNew = document.createEvent('Event');
      eventNew.initEvent('blur', false, false);
      el.dispatchEvent(eventNew);
    }
  }

  @HostListener('keydown.enter', ['$event.target', '$event.target.value'])
  onEnter(el: any, value: string): void {
    // Remove newline characters when Enter is pressed
    const newValue = value.replace(/\n/g, ' ');
    if (newValue !== value) {
      el.value = newValue;
      this.dispatchEvents(el);
    }
  }

  private dispatchEvents(el: any): void {
    const eventInput = document.createEvent('Event');
    eventInput.initEvent('input', false, false);
    el.dispatchEvent(eventInput);

    const eventBlur = document.createEvent('Event');
    eventBlur.initEvent('blur', false, false);
    el.dispatchEvent(eventBlur);
  }

}
